import { render, staticRenderFns } from "./ViewControlPositionOnDrawing.vue?vue&type=template&id=b985d194&"
import script from "./ViewControlPositionOnDrawing.vue?vue&type=script&lang=js&"
export * from "./ViewControlPositionOnDrawing.vue?vue&type=script&lang=js&"
import style0 from "./ViewControlPositionOnDrawing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports